export default __webpack_public_path__ + "static/media/alpharadar-watchlist.17475db5.jpg";